export interface IUsersItem {
  _id?: String
  createdAt: Date

  FirstName: string

  LastName: string

  Email: string

  Password: string

  ProfilePic: string
  Role: String
}

export interface IpaginatedUsers {
  docs: IUsersItem[]
  totalDocs: number
  offset: number
  limit: number
  totalPages: number
  page: number
  pagingCounter: number
  hasPrevPage: boolean
  hasNextPage: boolean
  prevPage: number | null
  nextPage: number | null
}
export interface ICardsdestinosItem {
  _id?: String
  createdAt: Date

  Picture: string

  Location: string

  Title: string

  Description: string

  Link: string
}

export interface IpaginatedCardsdestinos {
  docs: ICardsdestinosItem[]
  totalDocs: number
  offset: number
  limit: number
  totalPages: number
  page: number
  pagingCounter: number
  hasPrevPage: boolean
  hasNextPage: boolean
  prevPage: number | null
  nextPage: number | null
}
export interface ICardstourdesksItem {
  _id?: String
  createdAt: Date

  Picture: string

  Description: string

  Time: string

  Price: string

  LinkTourDesk: string
}

export interface IpaginatedCardstourdesks {
  docs: ICardstourdesksItem[]
  totalDocs: number
  offset: number
  limit: number
  totalPages: number
  page: number
  pagingCounter: number
  hasPrevPage: boolean
  hasNextPage: boolean
  prevPage: number | null
  nextPage: number | null
}
export interface ISeccionsociosItem {
  _id?: String
  createdAt: Date

  Picture: string

  Name: string

  LastName: string

  Role: string

  LinkedIn: string

  Email: string
}

export interface IpaginatedSeccionsocios {
  docs: ISeccionsociosItem[]
  totalDocs: number
  offset: number
  limit: number
  totalPages: number
  page: number
  pagingCounter: number
  hasPrevPage: boolean
  hasNextPage: boolean
  prevPage: number | null
  nextPage: number | null
}
export interface ICardspressItem {
  _id?: String
  createdAt: Date

  Picture: string

  Title: string

  Date: string

  Description: string

  Link: string
}

export interface IpaginatedCardspress {
  docs: ICardspressItem[]
  totalDocs: number
  offset: number
  limit: number
  totalPages: number
  page: number
  pagingCounter: number
  hasPrevPage: boolean
  hasNextPage: boolean
  prevPage: number | null
  nextPage: number | null
}
export interface IContactsItem {
  _id?: String
  createdAt: Date

  Name: string

  LastName: string

  Email: string

  Subject: string
  Message: String
}

export interface IpaginatedContacts {
  docs: IContactsItem[]
  totalDocs: number
  offset: number
  limit: number
  totalPages: number
  page: number
  pagingCounter: number
  hasPrevPage: boolean
  hasNextPage: boolean
  prevPage: number | null
  nextPage: number | null
}
export interface ICardsinstagramItem {
  _id?: String
  createdAt: Date

  Name: string

  Link: string

  Image: string

  Caption: string
}

export interface IpaginatedCardsinstagram {
  docs: ICardsinstagramItem[]
  totalDocs: number
  offset: number
  limit: number
  totalPages: number
  page: number
  pagingCounter: number
  hasPrevPage: boolean
  hasNextPage: boolean
  prevPage: number | null
  nextPage: number | null
}
export interface ISeccionmarketingsItem {
  _id?: String
  createdAt: Date

  Picture: string

  Name: string

  LastName: string

  Role: string

  LinkedIn: string

  Email: string
}

export interface IpaginatedSeccionmarketings {
  docs: ISeccionmarketingsItem[]
  totalDocs: number
  offset: number
  limit: number
  totalPages: number
  page: number
  pagingCounter: number
  hasPrevPage: boolean
  hasNextPage: boolean
  prevPage: number | null
  nextPage: number | null
}
export interface ISeccionitsItem {
  _id?: String
  createdAt: Date

  Picture: string

  Name: string

  LastName: string

  Role: string

  LinkedIn: string

  Email: string
}

export interface IpaginatedSeccionits {
  docs: ISeccionitsItem[]
  totalDocs: number
  offset: number
  limit: number
  totalPages: number
  page: number
  pagingCounter: number
  hasPrevPage: boolean
  hasNextPage: boolean
  prevPage: number | null
  nextPage: number | null
}
export interface ISeccionturismosItem {
  _id?: String
  createdAt: Date

  Picture: string

  Name: string

  LastName: string

  Role: string

  LinkedIn: string

  Email: string
}

export interface IpaginatedSeccionturismos {
  docs: ISeccionturismosItem[]
  totalDocs: number
  offset: number
  limit: number
  totalPages: number
  page: number
  pagingCounter: number
  hasPrevPage: boolean
  hasNextPage: boolean
  prevPage: number | null
  nextPage: number | null
}
export interface ISeccionfinanzasItem {
  _id?: String
  createdAt: Date

  Picture: string

  Name: string

  LastName: string

  Role: string

  LinkedIn: string

  Email: string
}

export interface IpaginatedSeccionfinanzas {
  docs: ISeccionfinanzasItem[]
  totalDocs: number
  offset: number
  limit: number
  totalPages: number
  page: number
  pagingCounter: number
  hasPrevPage: boolean
  hasNextPage: boolean
  prevPage: number | null
  nextPage: number | null
}
export interface ICardspartnersItem {
  _id?: String
  createdAt: Date
  PartnerName: Number

  PartnerLogo: string

  PartnerURL: string
}

export interface IpaginatedCardspartners {
  docs: ICardspartnersItem[]
  totalDocs: number
  offset: number
  limit: number
  totalPages: number
  page: number
  pagingCounter: number
  hasPrevPage: boolean
  hasNextPage: boolean
  prevPage: number | null
  nextPage: number | null
}
export interface ICarouseltoppagesItem {
  _id?: String
  createdAt: Date
  ID: Number

  Image: string
}

export interface IpaginatedCarouseltoppages {
  docs: ICarouseltoppagesItem[]
  totalDocs: number
  offset: number
  limit: number
  totalPages: number
  page: number
  pagingCounter: number
  hasPrevPage: boolean
  hasNextPage: boolean
  prevPage: number | null
  nextPage: number | null
}
export interface IToppagespressItem {
  _id?: String
  createdAt: Date
  ID: Number

  Image: string
}

export interface IpaginatedToppagespress {
  docs: IToppagespressItem[]
  totalDocs: number
  offset: number
  limit: number
  totalPages: number
  page: number
  pagingCounter: number
  hasPrevPage: boolean
  hasNextPage: boolean
  prevPage: number | null
  nextPage: number | null
}
export interface IToppagesjoinusItem {
  _id?: String
  createdAt: Date
  ID: Number

  Image: string
}

export interface IpaginatedToppagesjoinus {
  docs: IToppagesjoinusItem[]
  totalDocs: number
  offset: number
  limit: number
  totalPages: number
  page: number
  pagingCounter: number
  hasPrevPage: boolean
  hasNextPage: boolean
  prevPage: number | null
  nextPage: number | null
}
export interface IToppagesaboutusItem {
  _id?: String
  createdAt: Date
  ID: Number

  Image: string
}

export interface IpaginatedToppagesaboutus {
  docs: IToppagesaboutusItem[]
  totalDocs: number
  offset: number
  limit: number
  totalPages: number
  page: number
  pagingCounter: number
  hasPrevPage: boolean
  hasNextPage: boolean
  prevPage: number | null
  nextPage: number | null
}

export enum ApiStatus {
  NOTLOADED = 'notloaded',
  LOADING = 'loading',
  LOADED = 'loaded',
  FAILED = 'failed',
}
